import Axios from "axios";
import { studentFormFillUpOptionsUrl, StudentFormFillUpDetailsByID } from "../../api";
import { GET_STUDENT_FORM_FILL_UP_DETAILS_BY_ID } from '../../mutation-types'
import { student_token } from "../../erpUtil";
import {
  GET_STUDENT_FORM_FILL_UP_OPTIONS,
  UNSET_STUDENT_FORM_FILL_UP_OPTIONS
} from "../../mutation-types";
let token = localStorage.getItem("student_token");
if (token) {
  // Axios.defaults.headers.common["Authorization"] = "Bearer " + token;
  Axios.defaults.headers.common["token_name"] = student_token;
}
const state = {
  form_fill_up_options: [],
  studentFormFillupById: {},
};
const getters = {
  getStudentFormFillUpOptions(state) {
    return state.form_fill_up_options;
  },
  getTadaByIDOfFormFillup(state) {
    return state.studentFormFillupById;
  },
};
const mutations = {
  [GET_STUDENT_FORM_FILL_UP_OPTIONS](state, result) {
    state.form_fill_up_options = result;
  },
  [UNSET_STUDENT_FORM_FILL_UP_OPTIONS](state) {
    state.form_fill_up_options = [];
  },
  [GET_STUDENT_FORM_FILL_UP_DETAILS_BY_ID](state, response) {
    state.studentFormFillupById = response
  }
};
const actions = {
  fetchStudentFormFillupDetailsByID({ commit }, SearchPeram) {
    return Axios.get(StudentFormFillUpDetailsByID, { params: { id: SearchPeram } })
      .then((response) => {
        var resultByID = response.data.data;
        commit("GET_STUDENT_FORM_FILL_UP_DETAILS_BY_ID", resultByID);
      })
  },

  fetchStudentFormFillupDetailsByID2({ commit }, item) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", {
        color: "primary",
      });

      Axios.get(StudentFormFillUpDetailsByID, {
        params: { id: item },
        responseType: "blob",
      })
        .then(function (response) {
          commit("UNSET_LOADING");
          const contentType = response.headers["content-type"];
          if (contentType !== "application/pdf") {
            const reader = new FileReader();
            reader.onload = () => {
              const text = reader.result;
              const parsed = JSON.parse(text);
              commit("SET_SNACKBAR", {
                msg: parsed.message || "Unexpected response",
                color: "red",
              });
              reject();
            };
            reader.readAsText(response.data);
            return;
          }
          resolve(response.data);
        })
        .catch(function (error) {
          commit("UNSET_LOADING");
          commit("SET_SNACKBAR", {
            msg: "Download failed",
            color: "red",
          });
          reject();
        });
    });
  },



  // fetchStudentFormFillUpOptions({ commit, state }, authStudent) {
  //   localStorage.removeItem("student_form_fill_up_subjects");
  //   console.log('reset>>student_form_fill_up_subjects')
  //   commit("UNSET_STUDENT_FORM_FILL_UP_Subject");
  //   console.log('reset>>UNSET_STUDENT_FORM_FILL_UP_Subject')
  //   commit("UNSET_STUDENT_FORM_FILL_UP_FEES")
  //   console.log('reset>>UNSET_STUDENT_FORM_FILL_UP_FEES')
  //   let url = `${studentFormFillUpOptionsUrl}/${authStudent.std_id}`;
  //   return new Promise(function(resolve, reject) {
  //     commit("SET_LOADING", { color: "primary" });
  //     Axios.get(url, {
  //       headers: {
  //         token_name: student_token
  //       }
  //     })
  //       .then(function(response) {
  //         let result = response.data.data;
  //         commit("GET_STUDENT_FORM_FILL_UP_OPTIONS", result);
  //         resolve();
  //       })
  //       .catch(function(error) {
  //         commit("UNSET_STUDENT_FORM_FILL_UP_OPTIONS");
  //         reject();
  //       })
  //       .then(always => {
  //         commit("UNSET_LOADING");
  //       });
  //   });
  // }
  fetchStudentFormFillUpOptions({ commit, state }, authStudent) {

    localStorage.removeItem("student_form_fill_up_subjects");

    console.log("reset>>student_form_fill_up_subjects");

    commit("UNSET_STUDENT_FORM_FILL_UP_Subject");

    console.log("reset>>UNSET_STUDENT_FORM_FILL_UP_Subject");

    commit("UNSET_STUDENT_FORM_FILL_UP_FEES");

    console.log("reset>>UNSET_STUDENT_FORM_FILL_UP_FEES");

    let url = `${studentFormFillUpOptionsUrl}/${authStudent.std_id}`;

    return new Promise(function (resolve, reject) {

      commit("SET_LOADING", { color: "primary" });

      Axios.get(url, {
        headers: {
          token_name: student_token
        }
      })
        .then(function (response) {
          console.log("Tanvir! ff_response", response);
          // Custom API response check
          if (response.data.code == 404) {
            commit("UNSET_STUDENT_FORM_FILL_UP_OPTIONS");
            commit("SET_SNACKBAR", {
              msg: response.data.message || "Data not found",
              color: "red",
            });
            reject(response.data.message);
            return;
          }
          let result = response.data.data;
          commit("GET_STUDENT_FORM_FILL_UP_OPTIONS", result);
          resolve(result);

        })
        .catch(function (error) {
          console.log("Tanvir! ff_response", error);
          commit("UNSET_STUDENT_FORM_FILL_UP_OPTIONS");
          commit("SET_SNACKBAR", {
            msg:
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              "Download failed",
            color: "red",
          });
          reject(error);
        })
        .then(() => {
          commit("UNSET_LOADING");
        });

    });
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
